import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=a6ab4522"
import script from "./Sliders.vue?vue&type=script&lang=ts"
export * from "./Sliders.vue?vue&type=script&lang=ts"
import style0 from "./Sliders.vue?vue&type=style&index=0&id=a6ab4522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports